<template>
  <div class="action-bar">
    <div class="input-group">
      <div class="input-filter">
        <input v-model="filterComputed" placeholder="Rechercher une dépense" />
      </div>
      <div class="elicut sort-by">
        Trier par:
        <select v-model="sortByInput">
          <option value="title">Libellé</option>
          <option value="created_at">Date de création</option>
        </select>
      </div>
    </div>
    <div class="elicut create-event btn-c" @click="newEventAction()">
      Ajouter une nouvelle dépense
    </div>
  </div>
</template>

<script>
import { Component, BaseComponent } from '@/libs/BaseComponent'

@Component({
  props: {
    sortBy: {
      type: String
    },
    asc: {
      type: Boolean
    },
    filter: {
      type: String
    },
    newEventAction: {
      type: Function,
      default: () => null
    }
  }
})
export default class ActionBar extends BaseComponent {
  get sortByInput () {
    return this.sortBy
  }
  set sortByInput (value) {
    this.$emit('update:sortBy', value)
  }

  get filterComputed () {
    return this.filter
  }
  set filterComputed (value) {
    this.$emit('update:filter', value)
  }
}
</script>

<style lang="scss" scoped>
  .action-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 100%;
    padding:0 20px 0 20px;

    .input-group {
      display:flex;
      align-items: center;
      color: #818588;

      .input-filter {
        margin-right: 20px;

        input {
          border-radius: 8px;
          border: 1px solid #818588;
          padding: 10px;
          min-width: 300px;
          background: #2c3033;
          color: #818588;
          text-align: center;
          font-size: 14px;
        }
      }

      .sort-by {

        select {
          color: #fff;
          background: none;
          border: none;
          font-size: 14px;
          outline: none;
          -moz-appearance:none; /* Firefox */
          -webkit-appearance:none; /* Safari and Chrome */
        }
      }
    }

    .create-event {
      padding: 10px 20px 10px 20px;
      background: #fdd318;
      border-radius: 8px;
      color: #222;
      cursor: pointer;

      &:hover {
        filter: brightness(120%);
      }
    }
  }
</style>
